import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import {Formik, Form} from "formik";
import {
  addPhieuKeHoach,
  getListHD, getTechTransferPersonnel,
  searchdsDot,
  searchOptionNhanVien,
  updatePhieuKeHoach
} from "../services/services";
import {CODE, MAX_PAGE_SIZE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import TableThongTinDot from "./TableThongTinDot"
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import DialogThongTinDot from "./DialogThongTinDot";
import {TYPE_KB_CB} from "../constants/constansKeHoach";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TableNhanLuc from "./TableNhanLuc";
import TextField from "../../../../component/TextField";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogPhieuChuyenGiaoKyThuat = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [isViewDot, setIsViewDot] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [dsDot, setDsDot] = useState([]);
  const [selectedHopDong, setSelectedHopDong] = useState<any>(null);
  const [thanhVien, setThanhVien] = useState<any>([]);
  const [selectedTiepNhanHoTro, setSelectedTiepNhanHoTro] = useState<any>(null);
  const [dsItems, setDsItems] = useState<any[]>([]);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);
  const [contentTransfer, setContentTransfer] = useState<string>('');
  const [timeTransfer, setTimeTransfer] = useState<string>('');

  const getOptions = async () => {
    try {
      setIsLoading(true);
      const [nhanVien] = await Promise.all([
        searchOptionNhanVien({pageSize: MAX_PAGE_SIZE}),
      ]);

      setThanhVien(nhanVien?.data?.data?.content ?? []);
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
      toast.error("Không thể tải danh sách cán bộ");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddItem = async () => {
    if (!contentTransfer?.trim()) {
      toast.warning("Vui lòng nhập nội dung chuyển giao");
      return;
    }
    if (!timeTransfer?.trim()) {
      toast.warning("Vui lòng nhập thời gian");
      return;
    }
    if (!selectedTiepNhanHoTro) {
      toast.warning("Vui lòng chọn cán bộ đi CGKT");
      return;
    }

    const newItem = {
      contentTransfer: contentTransfer,
      timeTransfer: timeTransfer,
      personnelName: selectedTiepNhanHoTro?.fullName || selectedTiepNhanHoTro?.name || '',
      personnelId: selectedTiepNhanHoTro?.id,
      position: selectedTiepNhanHoTro?.position || '',
      unitName: selectedTiepNhanHoTro?.unitName || selectedTiepNhanHoTro?.department || '',
      quantityOfficer: selectedTiepNhanHoTro?.quantityOfficer || selectedTiepNhanHoTro?.education || '',
    };

    if (editingIndexTren !== null) {
      // Cập nhật item đang edit
      const updatedItems = [...dsItems];
      updatedItems[editingIndexTren] = newItem;
      setDsItems(updatedItems);
      setEditingIndexTren(null);
      toast.success("Cập nhật nội dung chuyển giao thành công");
    } else {
      // Thêm mới
      setDsItems([...dsItems, newItem]);
      toast.success("Thêm nội dung chuyển giao thành công");
    }

    // Reset form
    setContentTransfer('');
    setTimeTransfer('');
    setSelectedTiepNhanHoTro(null);
  };

  const handleEditItem = (index: number) => {
    const item = dsItems[index];
    setEditingIndexTren(index);

    // Tìm lại object trong danh sách thanhVien để set vào autocomplete
    const foundPerson = thanhVien.find((tv: any) => tv.id === item.personnelId);
    if (foundPerson) {
      setSelectedTiepNhanHoTro(foundPerson);
    }
    setContentTransfer(item?.contentTransfer);
    setTimeTransfer(item?.timeTransfer);
  };

  const handleDelete = (index: number) => {
    const updatedItems = dsItems.filter((_, i) => i !== index);
    setDsItems(updatedItems);
    toast.success("Xóa nội dung chuyển giao thành công");

    // Reset edit state nếu đang edit item bị xóa
    if (editingIndexTren === index) {
      setEditingIndexTren(null);
      setContentTransfer('');
      setTimeTransfer('');
      setSelectedTiepNhanHoTro(null);
    }
  };

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values[type?.formThongTinChung],
      type: TYPE_WH.EXPORT,
      doCreation: values?.keHoach?.id ? formatDateDTO(values?.keHoach?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      listPersonnel: dsItems.map(item => ({
        ...item,
        id: item?.id || null,
      })),
      contractInformation: selectedHopDong?.code,
      contractInformationName: selectedHopDong?.name,
      contractSignedAmount: selectedHopDong?.contractSignedAmount,
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };

    console.log('Form values:', values);
    console.log('Data submit:', dataSubmit);

    try {
      setIsLoading(true);
      const id = values[type?.formThongTinChung]?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        toast.success(((id) ? "Cập nhật" : "Thêm") + " bổ sung thông tin kỹ thuật thành công");
        onHide();
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initialValues?.id && updatePageData()
  }, [initialValues?.id])

  const updatePageData = async () => {
    try {
      setSelectedHopDong({
        code: initialValues?.[type?.formThongTinChung]?.contractInformation || initialValues?.contractInformation || selectedHopDong?.code,
        name: initialValues?.[type?.formThongTinChung]?.contractInformationName || initialValues?.contractInformationName || selectedHopDong?.name,
        contractSignedAmount: initialValues?.[type?.formThongTinChung]?.contractSignedAmount || initialValues?.contractSignedAmount || selectedHopDong?.contractSignedAmount,
      })

      // Load danh sách nhân sự từ initialValues
      if (initialValues?.[type?.formThongTinChung]?.listPersonnel) {
        setDsItems(initialValues[type.formThongTinChung].listPersonnel);
      } else if (initialValues?.listPersonnel) {
        setDsItems(initialValues.listPersonnel);
      }

      const {data} = await searchdsDot(initialValues?.[type?.formThongTinChung]?.id ?? initialValues?.id);
      const listPersonnel = await getTechTransferPersonnel(initialValues?.[type?.formThongTinChung]?.id ?? initialValues?.id);
      setDsItems(listPersonnel?.data)
      setDsDot([])
      if (CODE.SUCCESS === data.code) {
        setDsDot(data?.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    updateForm();
    getOptions();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    console.log(generateInitValues(data))
    setInitialValues({...generateInitValues(data), ...initialValues ?? {}});
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
    setIsViewDot(false);
    updatePageData()
  };

  const columns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 120,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center gap-2">
              <i
                onClick={() => handleEditItem(index)}
                className="bi bi-pencil-square text-primary cursor-pointer"
                style={{cursor: 'pointer'}}
                title="Sửa"
              ></i>
              <i
                onClick={() => handleDelete(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{cursor: 'pointer'}}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Nội dung chuyển giao",
      field: "contentTransfer",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.contentTransfer || '',
    },
    {
      name: "Thời gian",
      field: "timeTransfer",
      headerStyle: {
        minWidth: 150,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.timeTransfer || '',
    },
    {
      name: "Cán bộ đi CGKT",
      field: "personnelName",
      headerStyle: {
        minWidth: 150,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 150,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 150,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || '',
    },
  ];

  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type.formThongTinChung]: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, type?.formThongTinChung || "")}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={type.name}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    lstSelectedRenderButton={dsKeHoach}
                    setFieldValue={setFieldValue}
                    modelID={type?.formThongTinChung}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />

                  <div className="spaces fw-bold">
                    <hr/>
                  </div>
                  <div className="spaces 2 title">
                    <span className="title">
                      Nội dung đã chuyển giao
                    </span>
                  </div>
                  {!isView && (
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Nội dung chuyển giao"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} className="spaces">
                        <TextField
                          name='contentTransfer'
                          value={contentTransfer}
                          onChange={(e: any) => setContentTransfer(e.target.value)}
                          placeholder="Nhập nội dung chuyển giao..."
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Thời gian"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={2} className="spaces">
                        <TextField
                          name='timeTransfer'
                          value={timeTransfer}
                          onChange={(e: any) => setTimeTransfer(e.target.value)}
                          placeholder="Nhập thời gian..."
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired className="min-w-100px" label="Cán bộ đi CGKT"/>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} className="spaces">
                        <AutocompleteObjectV2
                          options={thanhVien}
                          value={selectedTiepNhanHoTro}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedTiepNhanHoTro(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          placeholder="Chọn cán bộ..."
                        />
                      </Col>
                      <Col lg={1}>
                        <div className="d-flex mt-8 spaces align-items-center">
                          <Button
                            className="btn-fill spaces min-w-90px btn btn-primary"
                            onClick={handleAddItem}
                            type="button"
                          >
                            <i className={`bi ${editingIndexTren !== null ? 'bi-pencil-square' : 'bi-plus-lg'} text-pri fs-3`}></i>
                            {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <TableNhanLuc
                    columns={columns}
                    isView={isView}
                    dsItems={dsItems}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    tracker={type.trackerCode}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                    onHide={onHide}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
                <Button onClick={() => onHide()} className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave/> Đóng
                </Button>
              </div>
            </Form>
          </>
        )}
      </Formik>
      {openDialogThemMoi && <DialogThongTinDot
          type={TYPE_KB_CB.NOI_DUNG_CHUYEN_GIAO}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={{dotChuyenGiao: itemSelected}}
          setInitialValues={setItemSelected}
          isViewDot={isViewDot}
      />}
    </Modal>
  );
};

export default DialogPhieuChuyenGiaoKyThuat;